<template>
  <b-modal
    centered
    id="modal-policy-exchange"
    modal-class="overflow-hidden"
    static
    scrollable
    ignore-enforce-focus-selector="input"
  >
    <template #modal-header="">
      <h5>Ý kiến BH tổng</h5>
      <b-button size="sm" variant="light" @click="closeModal()"> x </b-button>
    </template>
    <form @submit.prevent="updateInfo">
      <div>
        <div class="form-group">
          <label>{{
            this.dataPolicyExchange.type === 'ASK' ? 'Đề xuất phương án' : 'Phương án xử lý'
          }}</label>
          <Select2 v-model="solution" :options="Config.treatmentMethodOption" placeholder="Chọn" />
        </div>
        <div class="form-group">
          <label>{{
            this.dataPolicyExchange.type === 'ASK' ? 'Ghi chú xin ý kiến' : 'Ghi chú BH tổng'
          }}</label>
          <input v-model="note" placeholder="Ghi chú" />
        </div>
      </div>
    </form>
    <template #modal-footer>
      <b-button class="btn-style" size="sm" type="button" variant="light" @click="closeModal()">
        Hủy bỏ
      </b-button>
      <b-button class="btn-style" type="submit" size="sm" variant="primary" @click="updateInfo()">
        Xác nhận
      </b-button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </b-modal>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  export default {
    name: 'modal-device-ass-mc',
    props: {
      dataPolicyExchange: {
        type: Object,
      },
      closeModal: {
        type: Function,
      },
    },
    data() {
      return {
        Config,
        showLoading: false,
        solution: '',
        note: '',
      }
    },
    methods: {
      async updateInfo() {
        try {
          this.showLoading = true
          const params = {
            id: this.dataPolicyExchange.id,
            solution: this.solution,
            note: this.note,
          }
          let data
          if (this.dataPolicyExchange.type === 'ASK') {
            data = await DeviceService.policyExchangeAsk(params)
          } else if (this.dataPolicyExchange.type === 'RELY') {
            data = await DeviceService.policyExchangeRely(params)
          }
          if (data.code === 1000) {
            this.showSuccessMx('Thành công')
            this.$emit('updateInfoPolicyExchange')
          } else this.showFailMx(data.message)
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
